import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }, bodyParams) => {
  const endpoint = URLS.reports.reservations;
  return httpClient.post(endpoint, bodyParams).then(res => {
    // this field is an object, which means the transformClientResponse will try to camcelCase it; but the
    // keys are the names of classes, and should not be transformed
    const unserializedClassInfoObj = res.data.class_ids;

    const transformedRes = transformV2ClientResponse(res);
    transformedRes.classIds = unserializedClassInfoObj;
    return transformedRes;
  });
};

export default makeEntityScaffold('SAGA.API.REPORTS_RESERVATIONS', handler);
